<template>
  <div class="app">
    <div class="Edit-base">
      <div class="title">编辑教育经历</div>
      <div class="Edit-content">
        <div class="content-box">
          <div class="box-item">
            <div class="item-title">学校</div>
            <div class="item-content">
              <el-input size="small" placeholder="请输入学校名称" v-model="post.eduName" clearable>
              </el-input>
            </div>
          </div>
          <div class="box-item">
            <div class="item-title">起止时间</div>
            <div class="item-content eduTime">
              <el-date-picker size="small" v-model="post.startDate" type="month" popper-class="customePopper"
                placeholder="开始日期">
              </el-date-picker>
              <span style="margin: 0 10px;">至</span>
              <el-date-picker size="small" v-model="post.endDate" type="month" class="pickerPlace"
                popper-class="customePopper" :picker-options="pickerOptions"
                :placeholder="post.endDate ? '至今' : '结束日期'">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="content-box">
          <div class="box-item education">
            <div class="item-title">学历</div>
            <div class="item-content degree">
              <el-select size="small" v-model="post.degree" placeholder="请选择学历">
                <el-option v-for="item in Edus" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <div class="unifie">
                <el-checkbox v-model="post.isUnifie" label="统招"></el-checkbox>
                <el-checkbox v-model="post.is211" label="211"></el-checkbox>
                <el-checkbox v-model="post.is985" label="985"></el-checkbox>
                <el-checkbox v-model="post.isOne" label="一本"></el-checkbox>
                <el-checkbox v-model="post.UnifieEdu" label="统招本科"></el-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="content-box">
          <div class="box-item">
            <div class="item-title">专业</div>
            <div class="item-content">
              <el-input size="small" placeholder="请输入所学专业" v-model="post.professional" clearable>
              </el-input>
            </div>
          </div>
          <div class="box-item">
            <div class="item-content btn">
              <el-button size="small" @click="cancel">取消</el-button>
              <el-button size="small" type="primary" @click="save">保存</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateeduInfo, AddEduInfo } from '@/request/api'
export default {
  props: {
    val: {
      type: Array,
      default: () => ({})
    },
    name: {
      type: String,
      default: ''
    },
    Index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      Edus: [{
        value: '1',
        label: '大专以下'
      }, {
        value: '2',
        label: '大专'
      }, {
        value: '3',
        label: '本科'
      }, {
        value: '4',
        label: '硕士'
      }, {
        value: '5',
        label: '博士'
      }, {
        value: '6',
        label: 'MBA/EMBA'
      }],
      post: {
        eduID: '',
        comID: '',
        startDate: null,// 开始时间
        endDate: null,// 结束时间
        eduName: '',// 学校名称
        degree: '',// 学历
        professional: '',// 专业
        isUnifie: false, // 统招
        UnifieEdu: false, // 统招本科
        is211: false,
        is985: false,
        isOne: false,
        username: '',
        resumeID: ''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "至今",
            onClick: (picker) => {
              picker.$emit("pick", '至今');
            }
          }
        ]
      },
      EduList: []
    }
  },
  watch: {
    value2(newVal, oldVal) {
      if (newVal === '至今') {
        this.type = '至今'
      }
      var val = new Date(newVal)
      let year = val.getFullYear();
      let month = val.getMonth() + 1
    },
    deep: true
  },
  created() {
    this.post.username = JSON.parse(sessionStorage.getItem('LoginInfo')).username
    if (this.name === 'AddeduNull') {
      return;
    }
    if (this.name !== 'EditEdu') {
      return;
    }
    this.post.comID = this.val[this.Index].companyID;
    this.post.eduID = this.val[this.Index].eduID;
    this.post.startDate = this.val[this.Index].startTime;
    this.post.endDate = this.val[this.Index].endTime === '9999.0' ? '至今' : this.val[this.Index].endTime;
    this.post.eduName = this.val[this.Index].eduName;
    this.post.degree = this.val[this.Index].degree == '9999' ? '' : this.val[this.Index].degree;
    this.post.professional = this.val[this.Index].professional == '9999' ? '' : this.val[this.Index].professional;
    this.post.isUnifie = this.val[this.Index].nationalUnified === 1 ? true : false;
    this.post.UnifieEdu = this.val[this.Index].nationalEdu === 1 ? true : false;
    this.post.is211 = this.val[this.Index].edu211 === 1 ? true : false;
    this.post.is985 = this.val[this.Index].edu985 === 1 ? true : false;
    this.post.isOne = this.val[this.Index].abook === 1 ? true : false;
  },
  methods: {
    cancel() {
      this.$emit("eduInfoShow", false);
    },
    textBetween(str, left_key, right_key) {
      var g_left = str.indexOf(left_key);
      if (g_left != -1) {
        g_left = g_left + left_key.length;
        var g_right = str.indexOf(right_key, g_left);
      }
      if (g_right != -1) {
        return str.substr(g_left, g_right - g_left);
      }
    },
    isPostDataEmpty(post) {
      // 检查 post 对象中的每个属性是否为空
      for (let key in post) {
        if (post.hasOwnProperty(key) && post[key] === '') {
          // 如果发现空属性，返回 true
          return true;
        }
      }
      // 如果所有属性都不为空，返回 false
      return false;
    },
    async save() {
      const date = new Date(this.post.startDate);
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // getMonth() 返回 0-11，表示 1-12 月
      this.post.startDate = `${year}.${month.toString().padStart(2, '0')}`;
      if (this.post.endDate === '至今') {
        this.post.endDate = '9999.0';
      } else {
        const date2 = new Date(this.post.endDate);
        const year2 = date2.getFullYear();
        const month2 = date2.getMonth() + 1; // getMonth() 返回 0-11，表示 1-12 月
        this.post.endDate = `${year2}.${month2.toString().padStart(2, '0')}`;
      }
      if (this.name === 'AddeduNull') {
        this.post.ID = this.$route.query.resumeID;
        if (this.isPostDataEmpty(this.post)) {
          this.$message.error('请填写完整信息');
          return;
        }
        const { data: res } = await AddEduInfo(this.post);
        this.$emit("eduInfoShow", true);
      }

      if (this.name !== 'EditEdu') {
        this.post.resumeID = this.$route.query.resumeID;
        this.post.comID = '0';
        this.post.eduID = '0';

        if (this.isPostDataEmpty(this.post)) {
          this.$message.error('请填写完整信息');
          return;
        }
        const { data: res } = await AddEduInfo(this.post);
        this.$emit("eduInfoShow", true);
      } else {
        this.post.resumeID = this.$route.query.resumeID;
        if (this.isPostDataEmpty(this.post)) {
          this.$message.error('请填写完整信息');
          return;
        }
        const { data: res } = await updateeduInfo(this.post);
        this.$emit("eduInfoShow", true);
      }

    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep input[aria-hidden=true] {
  display: none !important;
}

* {
  box-sizing: border-box;
}

.app {
  background: #fff;
  padding: 20px;

  .Edit-base {
    background: #f4f5fb;
    padding: 20px;
    box-sizing: border-box;

    .title {
      font-size: 18px;
      color: #333;
      margin-bottom: 20px;
    }

    .Edit-content {
      width: 100%;

      .content-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .box-item {
          width: 48%;
        }

        .education {
          width: 70%;
        }

        .item-title {
          font-size: 16px;
          color: #333;
          line-height: 40px;
        }

        .item-title::before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
        }

        .item-content {
          margin-bottom: 10px;
        }

        .degree {
          display: flex;
          align-items: center;

          .unifie {
            display: flex;
            align-items: center;
            padding-left: 15px;

            ::v-deep .el-checkbox {
              margin-right: 15px;
            }
          }
        }

        .eduTime {
          display: flex;
          align-items: center;
        }

        .btn {
          display: flex;
          padding-top: 40px;

          .el-button {
            width: 50%;
          }
        }
      }


    }
  }
}
</style>